import { render, staticRenderFns } from "./Experiment.vue?vue&type=template&id=40fda200&scoped=true"
import script from "./Experiment.vue?vue&type=script&lang=js"
export * from "./Experiment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fda200",
  null
  
)

export default component.exports